import { ITC, ERRORLIST, SIGNAL } from "../../util/eventTypes"
import UserEvents from "../../signal/userEvents"
import BaseEvent from "../../util/baseEvent"
import Discover1 from "./discover"
import Discover2 from "./discover2"
import FetchWebsocketService from "./fetchWebsocketService"
import CreateSocket from "./createSocket"
import ConnectOvertimeManage from "./connectOvertimeManage"
import delay from "../../util/delay"
import WsStaticConnect from "./wsStaticConnect"
class SignalSDK extends BaseEvent {
  constructor(config, version = "v1") {
    super()
    this.version = version
    this.options = Object.assign(
      {},
      {
        secret: false,
        needClassinfo: true,
        env: "web",
        speedEp: "",
        extend: "",
        idcList: [],
        timelineList: [],
        token: ""
      },
      config
    )
    this.reconnectCount = 0
  }
  /**
   * 执行连接
   **/
  connect() {
    this.addEventLisenter()
    this.log("==========进入信令房间==connect=========")
    this.discover =
      this.version === "v1"
        ? new Discover1(this.options)
        : new Discover2(this.options)
    this.fetchWebsocketService = new FetchWebsocketService()
    this.websocketService = new CreateSocket(this.options)
    this.wsStaticConnect = new WsStaticConnect(this.options)
    this.connectOvertimeManage = new ConnectOvertimeManage()
    this.discover.start(this.options.idcList)
  }
  /**
   * 注册监听时间
   **/
  addEventLisenter() {
    // 获取到EP节点 之后获取EP上的websocket服务
    this.receive(ITC.PING_SUCCESS /* DISCOVER.GET_NODE */, ep => {
      this.fetchWebsocketService.fetch(ep)
    })
    // 获取到EP上的websocket服务
    this.receive(
      ITC.FETCH_WS_SERVICE_SUCCESS /* DISCOVER.FETCH_WS_SUCCESS */,
      wsAddress => {
        this.websocketService.connect(wsAddress, this.reconnectCount)
      }
    )
    // 重连次数 如果是1的话表示是用户主动发起的进入教室成功 否则表示重连
    this.receive(ITC.CONNECTED /* DISCOVER.CONNECTED */, (data, ws) => {
      this.reconnectCount += 1
      if (this.reconnectCount !== 1) {
        this.emit("reconnect", "connected", ws)
        return
      }
      this.emit("connected", data, ws)
    })
    this.receive(ITC.MESSAGE /* DISCOVER.MESSAGE */, data => {
      this.emit("message", data)
    })
    // 接收到错误信令的时候 先销毁整个进程然后在中止整个连接
    this.receive(ITC.CLOSE /* DISCOVER.AGAIN */, reason => {
      this.debug(ITC.CLOSE)
      this.destroy()
      this.handleConnectionErrors(reason)
      // see lib/signal/index.ts:init(), search for discoverError
      this.emit("discoverError", reason)
    })
    this.receive(ITC.EXPORT_OUT /* LOG.EXPORT_OUT */, (message, logLevel) => {
      this.emit("exportOut", message, logLevel)
    })
    // openclass events
    this.receive("KEEP_ALIVE_FAIL", data => {
      this.emit("KEEP_ALIVE_FAIL", data)
    })
    this.receive("KEEP_ALIVE_DEALYTIME", time => {
      this.emit("KEEP_ALIVE_DEALYTIME", time)
    })
    // 重连原因
    this.receive(ITC.ERROR, (reason, params = {}) => {
      this.debug(ITC.ERROR, `Reconnecting cause ${reason}`, params)
      this.handleConnectionErrors(reason, params)
      this.emit("reconnect", "ing", Object.assign({}, { reason }, params))
    })
  }
  handleConnectionErrors(reason, params = {}) {
    switch (reason) {
      case ERRORLIST.KICKOFF:
        this.rerror(SIGNAL.ENTER_SIGNAL_ROOM_FAIL, reason)
        this.emit(UserEvents.USER_ROOM_KICKOFF, reason)
        break
      case ERRORLIST.TOKEN_ERROR:
        this.rerror(SIGNAL.ENTER_SIGNAL_ROOM_FAIL, reason)
        this.emit("USER_SIGNAL_EXCEPTION", reason)
        break
      case ERRORLIST.NET_EXCEPTION:
        this.rerror(SIGNAL.ENTER_SIGNAL_ROOM_FAIL, "NET_EXCEPTION")
        this.emit("USER_SIGNAL_EXCEPTION", reason)
        break
      /* align with vipkid-signal-sdk */
      case ERRORLIST.SOCKET_ERROR:
        this.fetchWebsocketService.excludeWs(params.host)
      case ERRORLIST.EMPTY_IDC_LIST:
        this.reconnect(reason, params)
        break
      case ERRORLIST.EP_NODE_OVERLOAD:
        this.discover.shiftIdc()
        this.reconnect(reason, params)
        break
      default:
        this.rerror(SIGNAL.ENTER_SIGNAL_ROOM_FAIL, reason)
        this.reconnect(reason, params)
        this.emit("USER_SIGNAL_EXCEPTION", reason)
        break
    }
  }
  /**
   * reconnect again, considering SOCKET_ERROR reason
   *
   * @param   {string}  reason socket error detail
   * @param   {any}  params
   */
  reconnect(reason, params) {
    delay(100).then(() => {
      if (
        reason === ERRORLIST.ABOVE_MAX_DISCOVER_TIMES ||
        ERRORLIST.EMPTY_IDC_LIST
      ) {
        // try authInfo.signalSdk.wsStaticList
        this.wsStaticConnect.connect()
      } else {
        // still using authInfo.signalSdk.idcList
        this.discover.start(this.options.idcList)
      }
      this.emit("reconnect", "ing", Object.assign({ reason }, params))
    })
  }
  /**
   * 发送信令消息
   **/
  sendMessage(msg, callback) {
    this.websocketService.sendMessage(msg, callback)
  }
  /**
   * 添加报活信息
   **/
  addKeepliveInfo(params) {
    this.websocketService.addKeepliveInfo(params)
  }
  /**
   * 销毁信令
   **/
  destroy() {
    this.removeAllEventLisenter()
    this.reconnectCount = 0
    this.discover.destroy()
    this.connectOvertimeManage.destroy()
    this.websocketService.destroy()
  }
  /**
   * 移除监听
   **/
  removeAllEventLisenter() {
    this.eventEmitter.removeAllListeners(ITC.START_CONNECT)
    this.eventEmitter.removeAllListeners(ITC.PING_SUCCESS)
    this.eventEmitter.removeAllListeners(ITC.FETCH_WS_SERVICE_SUCCESS)
    this.eventEmitter.removeAllListeners(ITC.CONNECTED)
    this.eventEmitter.removeAllListeners(ITC.ERROR)
    this.eventEmitter.removeAllListeners(ITC.CLOSE)
    this.eventEmitter.removeAllListeners(ITC.RECORD_TIMELINE)
    this.eventEmitter.removeAllListeners(ITC.EXPORT_OUT)
  }
}
export default SignalSDK
// # sourceMappingURL=index.js.map
